import React, { useEffect, useState, useMemo, useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { ChevronLeft, X, Copy, MoreHorizontal } from "lucide-react";
import DynamicTable from "../../components/DynamicTable";
import SearchBox from "../../components/SearchBox";
import Pagination from "../../components/Pagination";
import emptySearchImg from "../../assets/img/brand/empty-search.png";
import FilterDrawer from "../../components/FilterDrawer";
import noStockImage from "../../assets/img/brand/no-brand-img.png";
import apiHelper from "../../apiHelper";
import StockOutModal from "./StockOutModal";
import Tooltip from "../addentities/Tooltip";
import AlertNotification from "../../components/AlertNotification";
import { formatDateTime } from "../../utils/formateDate";
export default function StockInstancePage() {
  // const start
  const breadcrumbs = ["Stock", "Stock List"];
  const history = useHistory();
  const location = useLocation();
  const { stock_id } = useParams();

  const stock = location.state?.stock || null;
  const fromPage = location.state?.page ?? 1;
  const tab = location.state?.tab;
  const reopenDrawer = location.state?.reopenDrawer;
  const stockId = location.state?.stockId;

  console.log(reopenDrawer);
  /* -------------------- STATE (same as SpuSkuPage) -------------------- */
  const [data, setData] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [sortField, setSortField] = useState("last_action");
  const [sortOrder, setSortOrder] = useState("desc");

  const PAGE_SIZE = 20;

  const selectedStock = location.state?.stock || null;
  const filterButtonRef = useRef(null);
  const activeTab = location.state?.stock || "stock";
  const [currentRow, setCurrentRow] = useState(null);
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const dropdownRef = useRef(null);
  const buttonRefs = useRef({});
  const toolbarRef = useRef(null);
  const [suppressHighlight, setSuppressHighlight] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [stockDrawerOpen, setStockDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  // New state for Stock Out modal
  const [stockOutModalOpen, setStockOutModalOpen] = useState(false);
  const [selectedStockInstanceForOut, setSelectedStockInstanceForOut] =
    useState(null);

  const isSearching = searchTerm.trim().length > 0;
  const drawerRef = useRef(null);
  const stockOutModalRef = useRef(null);

  const [branches, setBranches] = useState([]);

  const [drawerTab, setDrawerTab] = useState("general");

  const [copied, setCopied] = useState(false);
  const [toolbarDropdownOpen, setToolbarDropdownOpen] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  //const mid

  const [tempValues, setTempValues] = useState({
    branch: [],
    cost_price_min: "",
    cost_price_max: "",
  });

  const [filters, setFilters] = useState({
    branch: [],
    cost_price: [],
  });

  const [filterPopupOpen, setFilterPopupOpen] = useState(false);

  const FilterActiveIcon = () => (
    <svg
      style={{ margin: 0 }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.6325 6.44444C20.7252 6.24267 20.7746 6.02858 20.8107 5.74756C21.0354 4.00089 21.1478 3.12756 21.6356 2.56378C20.1234 2 19.2177 2 17.4063 2H4.59369C2.78227 2 1.87655 2 1.36439 2.56378C0.852232 3.12756 0.964572 4.00089 1.18925 5.74756C1.25487 6.25766 1.36399 6.54725 1.69704 6.94296C2.77293 8.22128 4.74334 10.4951 7.50829 12.5623C7.76095 12.7512 7.92676 13.0599 7.95475 13.4016C8.26623 17.2071 8.55159 19.8068 8.70309 21.0865C8.78256 21.7577 9.52673 22.274 10.14 21.8404C11.1702 21.1118 13.0947 20.2952 13.349 18.938C13.4692 18.2964 13.6451 17.1765 13.8437 15.3333"
        stroke="#0D6EFD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_4516_4830)">
        <path
          d="M22.8125 11C22.8125 14.2102 20.2102 16.8125 17 16.8125C13.7898 16.8125 11.1875 14.2102 11.1875 11C11.1875 7.78987 13.7898 5.18753 17 5.18753C20.2102 5.18753 22.8125 7.78987 22.8125 11ZM16.3277 14.0777L20.6402 9.7652C20.7866 9.61877 20.7866 9.38132 20.6402 9.23488L20.1099 8.70456C19.9634 9.5581 19.726 9.5581 19.5795 8.70456L16.0625 12.2215L14.4205 10.5795C14.2741 10.4331 14.0366 10.4331 13.8901 10.5795L13.3598 11.1099C13.2134 11.2563 13.2134 11.4937 13.3598 11.6402L15.7973 14.0777C15.9438 14.2241 16.1812 14.2241 16.3277 14.0777Z"
          fill="#0D6EFD"
        />
      </g>
      <defs>
        <clipPath id="clip0_4516_4830">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(11 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  const FilterInactiveIcon = () => (
    <svg
      style={{ margin: 0 }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333"
        stroke="#6C757D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445"
        stroke="#6C757D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const FilterDisabledIcon = () => (
    <svg
      style={{ margin: 0 }}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.6323 6.44444C21.7251 6.24267 21.7744 6.02858 21.8106 5.74756C22.0353 4.00089 22.1476 3.12756 21.6354 2.56378C21.1233 2 20.2176 2 18.4062 2H5.59366C3.78225 2 2.87655 2 2.36439 2.56378C1.85223 3.12756 1.96457 4.00089 2.18925 5.74756C2.25487 6.25766 2.36399 6.54725 2.69703 6.94296C3.77291 8.22128 5.74331 10.4951 8.50823 12.5623C8.76089 12.7512 8.9267 13.0599 8.95469 13.4016C9.26616 17.2071 9.55152 19.8068 9.70302 21.0865C9.78249 21.7577 10.5267 22.274 11.1399 21.8404C12.1701 21.1118 14.0946 20.2952 14.3489 18.938C14.4691 18.2964 14.645 17.1765 14.8436 15.3333"
        stroke="#CED4DA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.1113 7.5556V15.3334M22.0001 11.4445L14.2224 11.4445"
        stroke="#CED4DA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const isInitialTableEmpty = data.length === 0;

  // Image selection
  const stockEmptyImage = isInitialTableEmpty ? noStockImage : emptySearchImg;

  // Title selection
  const stockEmptyTitle = isInitialTableEmpty
    ? "No StockInstances Found"
    : isSearching
      ? "No Results Found"
      : "No StockInstances Match Filters";

  // Message selection
  const stockEmptyMessage = isInitialTableEmpty
    ? "This Stock does not have any StockInstances yet."
    : isSearching
      ? "No StockInstances match what you're searching for."
      : "No StockInstances match your applied filters.";

  const sections = [
    {
      label: "Branch",
      type: "list",
      key: "branch",
      showDropdownIcon: true,
      data: branches,
      renderItem: (item) => ({
        id: item.branch_id,
        title: item.branch_name,
      }),
    },
    {
      label: "Cost Price",
      type: "range",
      key: "cost_price",
      changeColor:true
    },
  ];

  const filtersApplied = Boolean(
    filters.branch.length || filters.cost_price.length
  );

  const isTableEmpty = isInitialTableEmpty && !isSearching && !filtersApplied;

  const Info = ({ label, value }) => {
    return (
      <div>
        <div
          style={{
            fontWeight: 700,
            marginBottom: 6,
            color: "#212529",
            fontSize:12,
            fontFamily: 'Montserrat'
          }}
        >
          {label}
        </div>
        <div style={{ color: "#1F1F1F", fontFamily: 'Montserrat',fontSize:12,fontWeight: 400}}>{value ?? "NA"}</div>
      </div>
    );
  };

  //   const end

  //   const function

  const toggleToolbarDropdown = () => {
    setToolbarDropdownOpen((prev) => !prev);
  };


  const filtered = data?.filter((item) =>
    JSON?.stringify(item)?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  //useeffect

  useEffect(() => {
    async function fetchBranches() {
      try {
        const res = await apiHelper("inventory/branches/", "GET");
        const data = await res.json();
        setBranches(data);
      } catch (e) {
        console.error("Branch API failed", e);
      }
    }

    fetchBranches();
  }, []);

  /* ------------------ TABLE PROCESSING ------------------ */
  const toggleSelect = () => { };
  const toggleAll = () => { };

  // Update the dropdown action button in the table:
  const toggleDropdown = (id,e) => {
    console.log("Toggling dropdown for ID:", id);

    const clickedRow = data.find((item) => item.id === id); // FIXED: Use 'id' instead of 'sku_id'
    setCurrentRow(clickedRow);

    if (dropdownOpenId === id) {
      setDropdownOpenId(null);
      return;
    }

    const btn = buttonRefs.current[id];
    if (!btn) {
      console.warn("Button ref missing for ID:", id);
      setDropdownOpenId(id);
      return;
    }

    // const rect = btn.getBoundingClientRect();
    const rect = e.currentTarget.getBoundingClientRect();
    const dropdownWidth = 180;
    const dropdownHeight = 140;

    let left = rect.left + window.scrollX - dropdownWidth + rect.width;
    if (left < 10) left = 10;

    let top = rect.bottom + window.scrollY;
    if (top + dropdownHeight > window.scrollY + window.innerHeight) {
      top = rect.top + window.scrollY - dropdownHeight;
    }

    top = rect.bottom + window.scrollY -15;
    left = rect.left + window.scrollX - 150;

    setDropdownPosition({ top, left });
    setDropdownOpenId(id);
  };

  const handleViewStock = (row) => {
    console.log(row);
    setSelectedRow(row);
    setStockDrawerOpen(true);
    setDropdownOpenId(null);
    setToolbarDropdownOpen(false);
  };

  // Handle Stock Out function - FIXED
  const handleStockOut = async (stockOutData) => {
    try {
      // The API call is now handled in the StockOutModal component
      // We just need to refresh the data after successful stock out

      if (stockOutData && stockOutData.success) {
        // Refresh the stock instances list
        const refreshResponse = await apiHelper(
          `inventory/stock-instances/?stock_id=${stock_id}`,
          "GET"
        );

        if (refreshResponse.ok) {
          const apiData = await refreshResponse.json();
          // const mappedData = apiData.map((item) => ({
          //   id: item.stock_instance_id,
          //   openId: item.uuid,
          //   notes: item.notes,
          //   imei: item.barcode_imei || item.imei || "", // FIXED: Use correct field
          //   branch: item.branch || "NA", // FIXED: Use correct field
          //   cost_price: Number(item.cost_price) || 0,
          //   reserved: item.reserved_qty || 0, // FIXED: Use numeric value
          //   pending: [
          //     { type: "Inbounding", color: "#198754", count: 0 },
          //     { type: "Outbounding", color: "#FD7E14", count: 0 },
          //     { type: "Transferring", color: "#1b4b75ff", count: 0 },
          //     { type: "Distributing", color: "#a5172aff", count: 0 },
          //   ],
          //   inStock_Sellable: [
          //     {
          //       type: "In Stock",
          //       color: "#198754",
          //       count: item.stock_quantity || 0,
          //     },
          //     {
          //       type: "Sellable",
          //       color: "#FD7E14",
          //       count:
          //         stockOutData.remaining_quantity || item.stock_quantity || 0,
          //     },
          //   ],
          //   last_action: formatDateTime(item.modified_at),
          // }));
          const mappedData = apiData
          .map((item) => {

            const summary = item.stock_status_summary || {
              pending: [],
              inStock_Sellable: [],
              reserved: 0,
            };

            const sellableCount =
              summary.inStock_Sellable?.find(
                (s) => s.type === "Sellable"
              )?.count ?? 0;

            const reservedCount =
              summary.reserved ?? item.reserved_qty ?? 0;

            const inStockComputed = sellableCount + reservedCount;

            // build pending array first
            const pending = [
              {
                type: "Inbounding",
                color: "#198754",
                count:
                  summary.pending?.find((s) => s.type === "Inbounding")?.count ?? 0,
              },
              {
                type: "Distributing",
                color: "#FD7E14",
                count:
                  summary.pending?.find((s) => s.type === "Distributing")?.count ?? 0,
              },
              {
                type: "Transferring",
                color: "#2C7BE5",
                count:
                  summary.pending?.find((s) => s.type === "Transferring")?.count ?? 0,
              },
              {
                type: "Outbounding",
                color: "#DC3545",
                count:
                  summary.pending?.find((s) => s.type === "Outbounding")?.count ?? 0,
              },
              {
                type: "Outbounding (others)",
                color: "#DC3545",
                count:
                  summary.pending?.find((s) => s.type === "Outbounding (others)")?.count ?? 0,
              },
              {
                type: "Transit (Non Reserved)",
                color: "#DC3545",
                count:
                  summary.pending?.find((s) => s.type === "Transit (Non Reserved)")?.count ?? 0,
              },
            ];

            // build stock array
            const inStock_Sellable = [
              {
                type: "In Stock",
                color: "#198754",
                count: inStockComputed,
              },
              {
                type: "Sellable",
                color: "#FD7E14",
                count: sellableCount,
              },
            ];

            // total check
            const pendingTotal = pending.reduce(
              (sum, p) => sum + p.count,
              0
            );

            const stockTotal = inStock_Sellable.reduce(
              (sum, s) => sum + s.count,
              0
            );

            const reserved = reservedCount;

            // skip row if everything is zero
            if (pendingTotal + stockTotal + reserved === 0) {
              return null;
            }

            // keep row
            return {
              id: item.stock_balance_id,
              stock_instance_id: item.stock_instance_id,
              stock_balance_id: item.stock_balance_id,
              openId: item.uuid,
              notes: item.notes,

              imei: item.imei,

              branch: item.branch || "NA",
              branch_id: item.branch_id,

              cost_price: Number(item.cost_price),

              reserved,

              pending,
              inStock_Sellable,

              last_action: formatDateTime(item.modified_at),
              lastStockedBy: item.modified_by_name,
            };
          })
          .filter(Boolean); // removes null rows

          setData(mappedData);

          const updatedRow = mappedData.find(
            (item) => item.id === selectedRow?.id
          );

          if (updatedRow) {
            const sellable = updatedRow.inStock_Sellable.find(item => item.type === "Sellable")?.count || 0;
            if(sellable){
              setSelectedRow(updatedRow);  
            }
            else{
              setStockDrawerOpen(false);       
              setSelectedRow(null);            
            }
            
          }
          else{
            setStockDrawerOpen(false);       
            setSelectedRow(null);       
          }

          setToolbarDropdownOpen(false);
          
          setAlertType("success");
          setAlertMessage("Items Stocked Out Successfully");
          setShowAlert(true);
        }
      }
    } catch (error) {
      console.error("Error refreshing stock data:", error);
    }
  };
  const PendingInfoTooltip = () => {
    const [tip, setTip] = useState({ show: false, top: 0, left: 0 });
    return (
      <>
        <div
          style={{ display: "inline-flex", alignItems: "center", cursor: "default", marginLeft: 3 }}
          onMouseEnter={(e) => {
            const r = e.currentTarget.getBoundingClientRect();
            setTip({ show: true, top: r.top, left: r.left + r.width / 2 });
          }}
          onMouseLeave={() => setTip(t => ({ ...t, show: false }))}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <g clipPath="url(#pending_info_clip_si)">
              <path fillRule="evenodd" clipRule="evenodd" d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375 6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594 6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594 2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688 8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z" fill="#5E6E82" />
              <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969 4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094 4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934 7.34719 5.26684 7.39094 5.1456 7.39094C4.97372 7.39094 4.91122 7.27031 4.9556 7.05781L5.58122 4.11719Z" fill="#5E6E82" />
              <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875 5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375 5 3.4375Z" fill="#5E6E82" />
            </g>
            <defs>
              <clipPath id="pending_info_clip_si">
                <rect width="10" height="10" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        {tip.show && (
          <div style={{ position: "fixed", top: tip.top, left: tip.left, transform: "translate(-50%, calc(-100% - 8px))", background: "#495057", color: "white", padding: "16px", borderRadius: "8px", zIndex: 9999, minWidth: "300px", whiteSpace: "normal", pointerEvents: "none", fontFamily: "Montserrat", fontSize: "12px", fontWeight: 400, lineHeight: "1.5" }}>
            <div><strong>Outbounding:</strong> StockInstance outbound generated from Shopee, Lazada and TikTok orders.</div>
            <div style={{ marginTop: "8px" }}><strong>Outbounding (Others):</strong> StockInstance outbound generated from orders of other channels.</div>
            <div style={{ width: 0, height: 0, borderRight: "15px solid transparent", borderBottom: "15px solid transparent", borderTop: "15px solid #495057", position: "absolute", borderLeft: "15px solid transparent", left: "50%", top: "98%", transform: "translateX(-50%)" }} />
          </div>
        )}
      </>
    );
  };

  const StockStatCell = ({
  items = [],
}) => {
  if (!items.length)
    return <span style={{ color: "#ADB5BD" }}>NA</span>;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      {items.map((item) => (
        <div
          key={item.type}
          style={{
            display: "grid",
            gridTemplateColumns: "145px auto",
            alignItems: "center",
            columnGap: "12px",
            fontSize: 12,
          }}
        >
          {/* 1st Column: Dot + Type */}
          <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" style={{ flexShrink: 0 }}>
              <circle cx="4" cy="4" r="3" fill={item.color} />
            </svg>
            <span style={{ color: "#495057", whiteSpace: "nowrap" }}>
              {item.type}
            </span>
          </div>

          {/* 2nd Column: Count */}
          <span
            style={{
              textAlign: "left",
              fontWeight: 500,
              color: "#212529",
              fontVariantNumeric: "tabular-nums",
              fontFeatureSettings: '"tnum"',
            }}
          >
            {(item.count ?? 0).toLocaleString("en-SG")}
          </span>
        </div>
      ))}
    </div>
  );
};



  const StockStateCell = ({ items = [] }) => {
    if (!items.length) return <span style={{ color: "#ADB5BD" }}>NA</span>;
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
        {items.map((item) => (
          <div
            key={item.type}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontSize: "12px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" style={{ flexShrink: 0 }}>
                <circle cx="4" cy="4" r="3" fill={item.color} />
              </svg>
              <span style={{ color: "#495057" }}>{item.type}</span>
            </div>
            <span style={{ color: "#212529", fontWeight: 500 }}>
              {item.count?.toLocaleString() || 0}
            </span>
          </div>
        ))}
      </div>
    );
  };

  /* -------------------- COLUMNS -------------------- */
  const columns = [
    {
      field: "imei",
      label: "IMEI / Barcode",
      sortable: true,
      width: "16%",
    },
    {
      field: "branch",
      label: "Branch",
      sortable: true,
      width: "12%",
      render: (row) => (
        <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block" }}>
          {row.branch || <span style={{ color: "#ADB5BD" }}>NA</span>}
        </span>
      ),
    },
    {
      field: "cost_price",
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <span style={{fontWeight:700}}>Cost Price</span> <Tooltip title="Cost Price" body="The price paid to obtain this StockInstance. If there are multiple items under this StockInstance, Cost Price = Cost of all items / Qty of all items" >
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <g clipPath="url(#clip0_3856_30308)">
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375   
                                    6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594   
                                    6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594   
                                    2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688   
                                    8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322   
                                    7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784   
                                    6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0   
                                    3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z"
                  fill="#5E6E82"
                />
                <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969   
                                  4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094   
                                  4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934   
                                  7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559   
                                  7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875   
                                  5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375   
                                  5 3.4375Z" fill="#5E6E82" />
              </g>
              <defs>
                <clipPath id="clip0_3856_30308">
                  <rect width="10" height="10" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Tooltip>
        </span>
      ),
      sortable: true,
      width: "10%",
      render: (row) => (
        row.cost_price !== null && row.cost_price !== undefined
          ? `SGD ${Number(row.cost_price).toLocaleString("en-SG", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
          : <span style={{ color: "#ADB5BD" }}>NA</span>
      )
    },
    // {
    //   field: "reserved",
    //   label: "Reserved Qty",
    //   sortable: true,
    //   width: "12%",
    //   render: (row) => row.reserved || "0", // FIXED: Show reserved quantity
    // },
    {
      field: "inStock_Sellable", // FIXED: Match the field name in data
      label: (
        <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <span style={{fontWeight:700}}>In Stock Qty</span>
           {/* <Tooltip title="In Stock Qty" body={
    <>
      <b style={{fontWeight:800}}>In Stock:</b> the Qty of items which are already in a specific Branch under the current StockInstance
      <br />
      <b style={{fontWeight:800}}>Sellable:</b> the Qty of items which are already in a specific Branch and also not be reserved under the current StockInstance
    </>
  } >
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <g clipPath="url(#clip0_3856_30308)">
                <path fillRule="evenodd" clipRule="evenodd"
                  d="M5 9.375C6.16032 9.375 7.27312 8.91406 8.09359 8.09359C8.91406 7.27312 9.375   
                                    6.16032 9.375 5C9.375 3.83968 8.91406 2.72688 8.09359 1.90641C7.27312 1.08594   
                                    6.16032 0.625 5 0.625C3.83968 0.625 2.72688 1.08594 1.90641 1.90641C1.08594   
                                    2.72688 0.625 3.83968 0.625 5C0.625 6.16032 1.08594 7.27312 1.90641 8.09359C2.72688   
                                    8.91406 3.83968 9.375 5 9.375ZM5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322   
                                    7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784   
                                    6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0   
                                    3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10Z"
                  fill="#5E6E82"
                />
                <path d="M5.58122 4.11719L4.14997 4.29656L4.09872 4.53406L4.37997 4.58594C4.56372 4.62969   
                                  4.59997 4.69594 4.55997 4.87906L4.09872 7.04656C3.97747 7.60719 4.16435 7.87094   
                                  4.60372 7.87094C4.94435 7.87094 5.33997 7.71344 5.51935 7.49719L5.57434 7.23719C5.44934   
                                  7.34719 5.26684 7.39094 5.14559 7.39094C4.97372 7.39094 4.91122 7.27031 4.95559   
                                  7.05781L5.58122 4.11719Z" fill="#5E6E82" />
                <path d="M5 3.4375C5.34518 3.4375 5.625 3.15768 5.625 2.8125C5.625 2.46732 5.34518 2.1875   
                                  5 2.1875C4.65482 2.1875 4.375 2.46732 4.375 2.8125C4.375 3.15768 4.65482 3.4375   
                                  5 3.4375Z" fill="#5E6E82" />
              </g>
              <defs>
                <clipPath id="clip0_3856_30308">
                  <rect width="10" height="10" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </Tooltip> */}
        </span>
      ),
      width: "18%",
      // render: (row) => (
      //   <div
      //     style={{
      //       display: "flex",
      //       flexDirection: "column",
      //       gap: 4,
      //       minWidth: "120px",
      //     }}
      //   >
      //     {row.inStock_Sellable?.map((p, i) => (
      //       <div key={i} style={{ display: "flex", fontSize: 12 }}>
      //         <span style={{ color: p.color, marginRight: 4 }}>●</span>
      //         <span style={{ color: "#6C757D", marginRight: 4 }}>{p.type}</span>
      //         <strong>{p.count}</strong>
      //       </div>
      //     ))}
      //   </div>
      // ),
      render: (row) => <StockStatCell items={(row.inStock_Sellable || []).filter(i => i.type !== "Sellable")} />,
    },
    {
      field: "pending",
      label: (<span style={{ display: "inline-flex", alignItems: "center" }}>Pending<PendingInfoTooltip /></span>),
      width: "22%",
      render: (row) => <StockStatCell items={(row.pending || []).filter(p => !["Inbounding", "Distributing", "Transferring"].includes(p.type))} />,
      // render: (row) => (
      //   <div
      //     style={{
      //       display: "flex",
      //       flexDirection: "column",
      //       gap: 4,
      //       minWidth: "18%",
      //     }}
      //   >
      //     {row.pending?.map((p, i) => (
      //       <div key={i} style={{ display: "flex", fontSize: 12 }}>
      //         <span style={{ color: p.color, marginRight: 4 }}>●</span>
      //         <span style={{ color: "#6C757D", marginRight: 4, flex: 1, }}>{p.type}</span>
      //         <strong style={{
      //           // marginLeft: 8,
      //           minWidth: 20,
      //           textAlign: "right",   // ✅ aligns numbers
      //           flexShrink: 0,
      //         }}>{p.count}</strong>
      //       </div>
      //     ))}
      //   </div>
      // ),
    },
    {
      field: "last_action",
      label: "Last Stock-in Time",
      sortable: true,
      width: "13%",
    },
  ];

  /* -------------------- FETCH STOCK INSTANCES -------------------- */
  useEffect(() => {
    async function fetchStockInstances() {
      if (!stock_id) return;

      try {
        const response = await apiHelper(
          `inventory/stock-instances/?stock_id=${stock_id}`,
          "GET"
        );

        if (!response.ok) {
          throw new Error("Failed to fetch stock instances");
        }

        const apiData = await response.json();

        // const mappedData = apiData.map((item) => {
        //   // Safe fallback if backend doesn't provide summary
        //   const summary = item.stock_status_summary || {
        //     pending: [],
        //     inStock_Sellable: [],
        //     reserved: 0,
        //   };
        //   const sellableCount =
        //   summary.inStock_Sellable?.find(
        //     (s) => s.type === "Sellable"
        //   )?.count ?? 0;

        // const reservedCount =
        //   summary.reserved ?? item.reserved_qty ?? 0;

        // const inStockComputed = sellableCount + reservedCount;
        //   return {
        //     id: item.stock_instance_id,
        //     openId: item.uuid,
        //     notes: item.notes,

        //     // IMEI / Barcode
        //     imei: item.imei,

        //     // Branch / Location
        //     branch: item.branch || "NA",
        //     branch_id: item.branch_id,

        //     // Cost Price
        //     cost_price: Number(item.cost_price),

        //     // Reserved (from backend if available)
        //     reserved: summary.reserved ?? item.reserved_qty ?? 0,

        //     pending: [
        //       {
        //         type: "Inbounding",
        //         color: "#198754",
        //         count:
        //           summary.pending?.find((s) => s.type === "Inbounding")?.count ??
        //           0,
        //       },
        //       {
        //         type: "Distributing",
        //         color: "#FD7E14",
        //         count:
        //           summary.pending?.find((s) => s.type === "Distributing")?.count ??
        //           0,
        //       },
        //       {
        //         type: "Transferring",
        //         color: "#2C7BE5",
        //         count:
        //           summary.pending?.find((s) => s.type === "Transferring")?.count ??
        //           0,
        //       },
        //       {
        //         type: "Outbounding",
        //         color: "#DC3545",
        //         count:
        //           summary.pending?.find((s) => s.type === "Outbounding")?.count ??
        //           0,
        //       },
        //     ],

        //     inStock_Sellable: [
        //       {
        //         type: "In Stock",
        //         color: "#198754",
        //         count: inStockComputed,
        //       },
        //       {
        //         type: "Sellable",
        //         color: "#FD7E14",
        //         count:
        //           summary.inStock_Sellable?.find((s) => s.type === "Sellable")
        //             ?.count ?? 0,
        //       },
        //     ],

        //     // Last Action
        //     last_action: formatDateTime(item.modified_at),
        //     lastStockedBy: item.modified_by_name,
        //   };
        // });

        const mappedData = apiData
        .map((item) => {
          // fallback summary
          const summary = item.stock_status_summary || {
            pending: [],
            inStock_Sellable: [],
            reserved: 0,
          };

          const sellableCount =
            summary.inStock_Sellable?.find(
              (s) => s.type === "Sellable"
            )?.count ?? 0;

          const reservedCount =
            summary.reserved ?? item.reserved_qty ?? 0;

          const inStockComputed = 
            summary.inStock_Sellable?.find(
              (s) => s.type === "In Stock"
            )?.count ?? 0;;

          // build arrays first
          const pending = [
            {
              type: "Inbounding",
              color: "#198754",
              count:
                summary.pending?.find((s) => s.type === "Inbounding")?.count ?? 0,
            },
            {
              type: "Distributing",
              color: "#FD7E14",
              count:
                summary.pending?.find((s) => s.type === "Distributing")?.count ?? 0,
            },
            {
              type: "Transferring",
              color: "#2C7BE5",
              count:
                summary.pending?.find((s) => s.type === "Transferring")?.count ?? 0,
            },
            {
              type: "Outbounding",
              color: "#DC3545",
              count:
                summary.pending?.find((s) => s.type === "Outbounding")?.count ?? 0,
            },
            {
              type: "Outbounding (others)",
              color: "#DC3545",
              count:
                summary.pending?.find((s) => s.type === "Outbounding (others)")?.count ?? 0,
            },
            {
              type: "Transit (Non Reserved)",
              color: "#DC3545",
              count:
                summary.pending?.find((s) => s.type === "Transit (Non Reserved)")?.count ?? 0,
            },
          ];

          const inStock_Sellable = [
            {
              type: "In Stock",
              color: "#198754",
              count: inStockComputed,
            },
            {
              type: "Sellable",
              color: "#FD7E14",
              count: sellableCount,
            },
          ];

          // total count check
          const pendingTotal = pending.reduce(
            (sum, p) => sum + p.count,
            0
          );

          const stockTotal = inStock_Sellable.reduce(
            (sum, s) => sum + s.count,
            0
          );

          const reserved = reservedCount;

          // skip empty rows
          if (pendingTotal + stockTotal + reserved === 0) {
            return null;
          }

          // keep row
          return {
            id: item.stock_balance_id,
            stock_balance_id: item.stock_balance_id,
            stock_instance_id: item.stock_instance_id,
            openId: item.uuid,
            notes: item.notes,

            imei: item.imei,

            branch: item.branch || "NA",
            branch_id: item.branch_id,

            cost_price: Number(item.cost_price),

            reserved,

            pending,
            inStock_Sellable,

            last_action: formatDateTime(item.modified_at),
            lastStockedBy: item.modified_by_name,
          };
        })
        .filter(Boolean); // removes null rows

      setData(mappedData);

      } catch (error) {
        console.error("StockInstance fetch error:", error);
        setData([]);
      }
    }

    fetchStockInstances();
  }, [stock_id]);


  /* -------------------- SEARCH -------------------- */
  const filteredData = useMemo(() => {
    let results = data;

    // 🔹 Branch filter
    if (filters.branch.length) {
      results = results.filter((item) =>
        filters.branch.includes(item.branch_id)
      );
    }

    // 🔹 Cost price range filter
    if (filters.cost_price.length === 2) {
      const [min, max] = filters.cost_price;
      results = results.filter((item) => {
        if (typeof item.cost_price !== "number") return false;
        return item.cost_price >= min && item.cost_price <= max;
      });
    }

    // 🔹 IMEI search (already correct)
    if (searchTerm.trim()) {
      const term = searchTerm.toLowerCase();
      results = results.filter((item) =>
        item.imei?.toLowerCase().includes(term)
      );
    }

    return results;
  }, [data, filters, searchTerm]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  /* -------------------- SORT -------------------- */
  const sortedData = useMemo(() => {
    if (!sortField) return filteredData;

    return [...filteredData].sort((a, b) => {
      const aVal = a[sortField] ?? "";
      const bVal = b[sortField] ?? "";

      if (aVal < bVal) return sortOrder === "asc" ? -1 : 1;
      if (aVal > bVal) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  }, [filteredData, sortField, sortOrder]);

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  /* -------------------- PAGINATION -------------------- */
  const totalPages = Math.ceil(sortedData.length / PAGE_SIZE);

  const pageData = sortedData.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  );

useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      dropdownOpenId !== null &&
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setDropdownOpenId(null);
      setCurrentRow(null);
    }

    // ERP-4940: an outside click always closes the info drawer, even when the
    // Stock Out confirmation modal is open.
    if (
      stockDrawerOpen &&
      drawerRef.current &&
      !drawerRef.current.contains(event.target)
    ) {
      setStockDrawerOpen(false);
      setToolbarDropdownOpen(false);
    }

    if (
      toolbarDropdownOpen &&
      toolbarRef.current &&
      !toolbarRef.current.contains(event.target)
    ) {
      setToolbarDropdownOpen(false);
    }

  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [dropdownOpenId, stockDrawerOpen, toolbarDropdownOpen]);

  /* -------------------- RENDER -------------------- */
  return (
    <div className="company-body main-company-body-inner new-look">
      {/* ---------- Breadcrumb ---------- */}
      <div className="breadcrumb">
        {breadcrumbs
          .concat(
            selectedStock
              ? `${selectedStock.name} ${selectedStock.variant} ${selectedStock.condition} ${selectedStock.grading}`
              : "Stock Details",
          )
          .map((crumb, index, arr) => (
            <span key={index} className="breadcrumb-item">
              {crumb === "Stock List" ? (
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    history.push("/stock-list", {
                      page: fromPage,
                      tab: tab,
                      reopenDrawer: reopenDrawer,
                      stockId: stockId,
                    })
                  }
                >
                  {crumb}
                </span>
              ) : (
                crumb
              )}
              {index !== arr.length - 1}
            </span>
          ))}
      </div>
      {showAlert && (
  <AlertNotification
    type={alertType}
    recordName="stockOut"
    action="update"
    message={alertMessage}
    onClose={() => setShowAlert(false)}
  />
)}

      <div className="employee-tabs-container">
        <div className="tab-content" id="spu-content">
          <div className="info-section">
            <div
              className="edit-organisation-info"
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                padding: "12px 16px",
                borderRadius: "8px",
                background: "#FFF",
                boxShadow: "0 1px 4px rgba(0, 0, 0, 0.10)",
              }}
            >
              {/* LEFT SECTION */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                {console.log(selectedStock)}

                {/* BACK ARROW */}
                <button
                  //   onClick={() => {
                  //     history.push("/stock-list", {
                  //       page: fromPage,
                  //       activeTab: fromTab,
                  //     });
                  //   }}
                  onClick={() => {
                    history.push(`/stock-list`, {
                      page: fromPage,
                      tab: tab,
                      reopenDrawer: reopenDrawer,
                      stockId: stockId,
                    });
                  }}
                  style={{
                    background: "transparent",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {/* <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M15 6L9 12L15 18"
                      stroke="#1F1F1F"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg> */}
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18 12.0002C18 11.8013 17.921 11.6105 17.7803 11.4699C17.6397 11.3292 17.4489 11.2502 17.25 11.2502H8.5605L11.781 8.03122C11.9218 7.89039 12.0009 7.69938 12.0009 7.50022C12.0009 7.30105 11.9218 7.11005 11.781 6.96922C11.6402 6.82839 11.4492 6.74927 11.25 6.74927C11.0508 6.74927 10.8598 6.82839 10.719 6.96922L6.219 11.4692C6.14915 11.5389 6.09374 11.6216 6.05593 11.7128C6.01812 11.8039 5.99866 11.9016 5.99866 12.0002C5.99866 12.0989 6.01812 12.1965 6.05593 12.2877C6.09374 12.3788 6.14915 12.4615 6.219 12.5312L10.719 17.0312C10.8598 17.172 11.0508 17.2512 11.25 17.2512C11.4492 17.2512 11.6402 17.172 11.781 17.0312C11.9218 16.8904 12.0009 16.6994 12.0009 16.5002C12.0009 16.3011 11.9218 16.11 11.781 15.9692L8.5605 12.7502H17.25C17.4489 12.7502 17.6397 12.6712 17.7803 12.5305C17.921 12.3899 18 12.1991 18 12.0002Z" fill="#1F1F1F"/>
                  </svg>
                </button>

                {/* PRODUCT IMAGE */}
                <img
                  src={selectedStock?.avatar || "/placeholder.png"}
                  alt="avatar"
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 6,
                    objectFit: "cover",
                    border: "1px solid #E9ECEF",
                  }}
                />

                {/* TEXT BLOCK */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                  }}
                >
                  {/* NAME + VARIANT (INLINE) */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      flexWrap: "wrap",
                    }}
                  >
                    <h4
                      style={{
                        margin: 0,
                        color: "#212529",
                        fontSize: "20px",
                        fontWeight: 700,
                        lineHeight: "22px",
                      }}
                    >
                      {selectedStock?.name || "Stock Details"}
                    </h4>

                    <span
                      style={{
                        color: "#6B6E70",
                        fontSize: "16px",
                        fontWeight: 600,
                      }}
                    >
                      {selectedStock?.variant || "-"}{selectedStock?.model_number ? ` | ${selectedStock.model_number}` : ''}
                    </span>
                  </div>

                  {/* BADGES (NEXT LINE) */}
                  <div style={{ display: "flex", gap: 8 }}>
                    <span
                      style={{
                        background: "#FFEB00",
                        fontSize: 12,
                        fontWeight: 600,
                        padding: "3px 8px",
                        borderRadius: 12,
                      }}
                    >
                      {selectedStock?.condition}
                    </span>

                    <span
                      style={{
                        background: "#FFEB00",
                        fontSize: 12,
                        fontWeight: 600,
                        padding: "3px 10px",
                        borderRadius: 12,
                      }}
                    >
                      {selectedStock?.grading}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="info-card">
              <div className="entities-tab">
                <div className="toolbar">
                  <div className="toolbar-left">
                    <SearchBox
                      searchInput={searchInput}
                      setSearchInput={setSearchInput}
                      setSearchTerm={setSearchTerm}
                      setCurrentPage={setCurrentPage}
                      disabled={isTableEmpty}
                    />
                    <div style={{ position: "relative" }}>
                      <button
                        ref={filterButtonRef}
                        className={`icon-btn p-2 filter-btn ${filtersApplied ? "applied" : ""
                          }`}
                        onClick={() =>
                          !isTableEmpty &&
                          setFilterPopupOpen(!filterPopupOpen)
                        }
                        disabled={isTableEmpty}
                        style={{
                          border: isTableEmpty
                            ? "1px solid var(--Gray-400, #CED4DA)"
                            : filtersApplied
                              ? "1px solid #2C7BE5"
                              : "1px solid #6C757D",
                          borderWidth: "1px",
                          color: isTableEmpty
                            ? "#CED4DA"
                            : filtersApplied
                              ? "#2C7BE5"
                              : "#6C757D",
                          background: isTableEmpty
                            ? "var(--Gray-100, #F8F9FA)"
                            : filtersApplied
                              ? "#CFE2FF"
                              : "#FFFFFF",
                          height: "40px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: isTableEmpty
                            ? "not-allowed"
                            : "pointer",
                          pointerEvents: isTableEmpty ? "none" : "auto",
                          borderRadius: "8px",
                        }}
                      >
                        {isTableEmpty ? (
                          <FilterDisabledIcon />
                        ) : filtersApplied ? (
                          <FilterActiveIcon />
                        ) : (
                          <FilterInactiveIcon />
                        )}
                      </button>
                    </div>
                    <FilterDrawer
                      isOpen={filterPopupOpen}
                      onClose={() => {
                        setTempValues({
                          branch: [],
                          cost_price_min: "",
                          cost_price_max: "",
                        });
                        setFilterPopupOpen(false);
                      }}
                      sections={sections}
                      tempValues={tempValues}
                      setTempValues={setTempValues}
                      onApply={() => {
                        const minRaw = tempValues.cost_price_min;
                        const maxRaw = tempValues.cost_price_max;

                        const hasMin = minRaw !== "" && !isNaN(minRaw);
                        const hasMax = maxRaw !== "" && !isNaN(maxRaw);

                        console.log(hasMin);
                        console.log(hasMax);
                        
                        let costPriceFilter = [];

                        if (hasMin && hasMax) {
                          costPriceFilter = [Number(minRaw), Number(maxRaw)];
                        } else if (hasMin) {
                          costPriceFilter = [Number(minRaw), Infinity];
                        } else if (hasMax) {
                          costPriceFilter = [0, Number(maxRaw)];
                        }

                        setFilters({
                          branch: tempValues.branch || [],
                          cost_price: costPriceFilter,
                        });
                        setCurrentPage(1);
                        setFilterPopupOpen(false);
                      }}
                      onClear={() => {
                        const empty = {
                          branch: [],
                          cost_price: [],
                        };
                        setTempValues(empty);
                        setFilters(empty);
                      }}
                    />
                  </div>
                </div>
                <div className="table-wrapper" style={{ border: "none" }}>
                  <DynamicTable
                    columns={columns}
                    data={pageData}
                    rowKey="id" // FIXED: Use 'id' instead of 'sku_id'
                    sortField={sortField}
                    sortOrder={sortOrder}
                    handleSort={handleSort}
                    onRowClick={handleViewStock}
                    showCheckbox={false}
                    selectedIds={selectedIds}
                    toggleSelect={toggleSelect}
                    toggleAll={toggleAll}
                    dropdownOpenId={dropdownOpenId}
                    stickyColumns={2}
                    resizableColumns={true}
                    suppressHighlight={suppressHighlight}
                    buttonRefs={buttonRefs}
                    onActionClick={(id,e) => toggleDropdown(id,e)}
                    emptyImage={stockEmptyImage}
                    emptyTitle={stockEmptyTitle}
                    emptyMessage={stockEmptyMessage}
                    showActions={true}
                  />
                  {dropdownOpenId !== null && (
                    <div
                      ref={dropdownRef}
                      className="backdrop-cls"
                      style={{
                        position: "absolute",
                        top: dropdownPosition.top,
                        left: dropdownPosition.left,
                        background: "white",
                        boxShadow: "0px 1px 4px 0px #0000001A",
                        zIndex: 1000,
                        minWidth: 152,
                        borderRadius: 8,
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="btn-align-forall">
                        <div className="common-for-all">
                          <button
                            onClick={() => {
                              handleViewStock(currentRow);
                            }}
                          >
                            View Details
                          </button>
                        </div>
                        {/* Stock Out Button */}
                        {/* <div className="common-for-all">
                          <button
                            onClick={() => {
                              setSelectedStockInstanceForOut(currentRow);
                              setStockOutModalOpen(true);
                              setDropdownOpenId(null);
                            }}
                          >
                            Stock Out
                          </button>
                        </div> */}
                        <div className="common-for-all">
                          <button
                            disabled
                            className="deactivate-cls"
                            style={{ opacity: 0.4, cursor: "not-allowed" }}
                          >
                            Stock Out
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {sortedData.length > 0 && (
                <div className="pagination">
                  <div className="pagination-info">
                    {/* {`${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(
                      currentPage * PAGE_SIZE,
                      filtered.length
                    )} of ${filtered.length} `} */}
                    {`${(currentPage - 1) * PAGE_SIZE + 1} - ${Math.min(
                      currentPage * PAGE_SIZE,
                      sortedData.length
                    )} of ${sortedData.length}`}
                  </div>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                  />
                </div>
                )}
                {stockDrawerOpen && selectedRow && (
                  <>
                    <div
                      className="drawer-overlay"
                      onMouseDown={(e) => {
                        setStockDrawerOpen(false);
                      }}
                    />
                    <div className="entity-drawer" ref={drawerRef}>
                      <div
                        className="drawer-header"
                        style={{ backgroundColor: "#F8F9FA" }}
                      >
                        <h3>StockInstance Info</h3>
                        <button
                          className="close-btn"
                          onClick={() => {
                            setStockDrawerOpen(false);
                            setSelectedIds((ids) =>
                              ids.filter((id) => id !== selectedRow?.id)
                            );
                            setSelectedRow(null);
                          }}
                        >
                          <X size={24} />
                        </button>
                      </div>
                      {/* info drawer */}
                      <div className="main-drawer-inner">
                        {/* ================= HEADER ================= */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 12,
                          }}
                        >
                          {/* LEFT: IMEI + Branch */}
                          <div>
                            <h3
                              style={{
                                margin: 0,
                                fontSize: '20px',
                                fontWeight: 600,
                                color: "#212529",
                                fontFamily: "Montserrat",
                              }}
                            >
                              {selectedRow?.imei || "—"}
                            </h3>

                            <div style={{ fontSize: '14px', fontWeight: 600, color: "#6C757D", fontFamily: "Montserrat", }}>
                              {selectedRow?.branch || "—"}
                            </div>
                          </div>

                          {/* RIGHT: MoreHorizontal */}
                          <div
                            className="toolbar"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                            }}
                            ref={toolbarRef}
                          >
                            <button
                              className="drawer-dots"
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleToolbarDropdown();
                              }}
                              style={{
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                padding: 4,
                              }}
                            >
                              <MoreHorizontal size={18} />
                            </button>

                            {toolbarDropdownOpen && (
                              <div
                                className="backdrop-cls"
                                style={{
                                  position: "absolute",
                                  top: 28,
                                  right: 0,
                                  background: "white",
                                  boxShadow: "0px 1px 4px 0px #0000001A",
                                  zIndex: 1000,
                                  minWidth: 152,
                                  borderRadius: 8,
                                }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div className="btn-align-forall">
                                  <div className="common-for-all">
                                    <button
                                      disabled
                                      className="deactivate-cls"
                                      style={{ opacity: 0.4, cursor: "not-allowed" }}
                                    >
                                      Stock Out
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* ================= TABS ================= */}
                        <div className="drawer-tabs">
                          <button
                            className={drawerTab === "general" ? "active" : ""}
                            onClick={() => setDrawerTab("general")}
                          >
                            General
                          </button>
                          {/* <button
                              className={
                                drawerTab === "configuration" ? "active" : ""
                              }
                              onClick={() => setDrawerTab("configuration")}
                            >
                              Configuration
                            </button> */}
                          <button
                            className={
                              drawerTab === "additional-info" ? "active" : ""
                            }
                            onClick={() => setDrawerTab("additional-info")}
                          >
                            Additional
                          </button>
                        </div>

                        {/* ================= GENERAL TAB ================= */}
                        {drawerTab === "general" && (
                          <>
                            {/*Stock Summary Cards*/}
                            <div
                              style={{
                                display: "flex",
                                gap: "12px",
                                marginTop: "16px",
                              }}
                            >
                              {/* ================= LEFT CARD ================= */}
                              <div
                                style={{
                                  flex: 1,
                                  border: "1px solid #E9ECEF",
                                  borderRadius: "8px",
                                  padding: "12px",
                                  background: "#fff",
                                  boxShadow: "1px 1px 4px #818181ff",
                                  display: "flex",
                                  flexDirection: "column", // ✅ important
                                }}
                              >
                                {/* Title */}
                                <div
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "#212529",
                                    fontFamily: "Montserrat",
                                  }}
                                >
                                  In Stock Qty
                                </div>

                                {/* List pushed to bottom */}
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    fontSize: "12px",
                                    fontFamily: "Montserrat",
                                    marginTop: "auto", // ✅ pushes list to bottom
                                    paddingTop: "8px",
                                  }}
                                >
                                  {(
                                    selectedRow?.inStock_Sellable || []
                                  ).filter(item => item.type !== "Sellable").map((item, index) => (
                                    <div
                                      key={index}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {/* Dot */}
                                      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" style={{ marginRight: 8, flexShrink: 0 }}>
                                        <circle cx="4" cy="4" r="3" fill={item.color} />
                                      </svg>

                                      {/* Label */}
                                      <span
                                        style={{
                                          color: "#6C757D",
                                          fontFamily: "Montserrat",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {item.type}
                                      </span>

                                      {/* Count */}
                                      <span
                                        style={{
                                          marginLeft: "auto",
                                          fontWeight: 600,
                                          color: "#212529",
                                          fontFamily: "Montserrat",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {item.count}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </div>

                              {/* ================= RIGHT CARD ================= */}
                              <div
                                style={{
                                  flex: 1,
                                  border: "1px solid #E9ECEF",
                                  borderRadius: "8px",
                                  padding: "12px",
                                  background: "#fff",
                                  boxShadow: "1px 1px 4px #818181ff",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    marginBottom: "8px",
                                    fontFamily: "Montserrat",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#212529",
                                      fontSize: "14px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    Pending<PendingInfoTooltip />
                                  </span>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    fontSize: "12px",
                                    fontFamily: "Montserrat",
                                  }}
                                >
                                  {(selectedRow?.pending || []).filter(p => !["Inbounding", "Distributing", "Transferring"].includes(p.type)).map(
                                    (p, i) => (
                                      <div
                                        key={i}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" style={{ marginRight: 6, flexShrink: 0 }}>
                                          <circle cx="4" cy="4" r="3" fill={p.color} />
                                        </svg>

                                        <span style={{ color: "#6C757D",marginRight:2 }}>
                                          {p.type}
                                        </span>
                                                                                <span
                                          style={{
                                            marginLeft: "auto",
                                            fontWeight: 600,
                                            color: "#212529",
                                          }}
                                        >
                                          {p.count}
                                        </span>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* ===== BASIC INFO ===== */}
                            <div
                              style={{
                                border: "1px solid #E9ECEF",
                                borderRadius: 12,
                                overflow: "hidden",
                                background: "#fff",
                                marginTop: 20,
                              }}
                            >
                              <div
                                style={{
                                  background: "#F8F9FA",
                                  padding: "15px 20px",
                                  fontWeight: 600,
                                  fontSize: '14px',
                                  fontFamily: 'Montserrat',
                                  color:'#212529'
                                }}
                              >
                                Basic Info
                              </div>

                              <div style={{ padding: 16 }}>
                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: 16,
                                    fontSize: 12,
                                  }}
                                >
                                  <Info
                                    label="IMEI / Barcode"
                                    value={selectedRow?.imei}
                                  />
                                  <Info
                                    label="Branch"
                                    value={selectedRow?.branch}
                                  />
                                  <Info
                                    label="Cost Price"
                                    value={
                                      selectedRow?.cost_price !== null && selectedRow?.cost_price !== undefined
                                        ? `SGD ${Number(selectedRow.cost_price).toLocaleString("en-SG", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}`
                                        : "SGD 0.00"
                                    }

                                  />
                                  {/* <Info
                                    label="Reserved Qty"
                                    value={selectedRow?.reserved}
                                  /> */}

                                  {/* Open ID (Full Width) */}
                                  <div style={{ gridColumn: "1 / -1" }}>
                                    <div
                                      style={{
                                        fontWeight: 600,
                                        marginBottom: 6,
                                        color:'#212529'
                                      }}
                                    >
                                      Open ID
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 6,
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {/* Open ID text */}
                                      <span
                                        style={{
                                          color: "#2C7BE5",
                                          cursor: "pointer",
                                          textDecoration: "underline",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                          maxWidth: 420, // ✅ keeps single line
                                          flexShrink: 1,
                                        }}
                                        title={selectedRow.openId || "—"}
                                        onClick={() => {
                                          // navigator.clipboard.writeText(selectedRow.openId);
                                          navigator.clipboard.writeText(
                                            selectedRow.openId || "—"
                                          );
                                          setCopied(true);
                                          setTimeout(
                                            () => setCopied(false),
                                            1500
                                          );
                                        }}
                                      >
                                        {/* {selectedRow.openId} */}
                                        {selectedRow.openId || "—"}
                                      </span>

                                      {/* Copy icon + tooltip anchor */}
                                      <span
                                        style={{
                                          position: "relative", // ✅ anchor for tooltip
                                          display: "inline-flex",
                                          alignItems: "center",
                                          flexShrink: 0,
                                        }}
                                        onClick={() => {
                                          // navigator.clipboard.writeText(selectedRow.openId);
                                          navigator.clipboard.writeText(
                                            selectedRow.openId || "—"
                                          );
                                          setCopied(true);
                                          setTimeout(
                                            () => setCopied(false),
                                            1500
                                          );
                                        }}
                                      >
                                        <Copy
                                          size={14}
                                          style={{
                                            color: "#2C7BE5",
                                            cursor: "pointer",
                                          }}
                                        />

                                        {/* ✅ Tooltip (NOT clipped now) */}
                                        {copied && (
                                                            <span
                                                                style={{
                                                                    fontSize: 12,
                                                                    color: "#0D6EFD",
                                                                    fontWeight: 500,
                                                                    marginLeft: 4,
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                Copied!
                                                            </span>
                                                        )}
                                      </span>
                                    </div>
                                  </div>

                                  <Info
                                    label="Last Stock-in By"
                                    value={selectedRow?.lastStockedBy}
                                  />
                                  <Info
                                    label="Last Stock-in Time"
                                    value={selectedRow?.last_action}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        {/* ================= ADDITIONAL TAB ================= */}
                        {drawerTab === "additional-info" && (
                          <div
                            style={{
                              border: "1px solid #E9ECEF",
                              borderRadius: 12,
                              background: "#fff",
                              overflow: "hidden",
                            }}
                          >
                            <div
                              style={{
                                background: "#F8F9FA",
                                padding: "10px 16px",
                                fontWeight: 600,
                                fontSize: 13,
                              }}
                            >
                              Notes
                            </div>
                            <div style={{ padding: 16, fontSize: 12, whiteSpace: "pre-wrap"  }}>
                              {selectedRow?.notes || "NA"}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`

.entities-table .actionHeader {
  width: 56px;
  min-width: 56px;
  max-width: 56px;
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 6;
}

.entities-table td.actionColumn,
.entities-table th.actionHeader {
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 10;
}

.entities-table td.firstColumn {
  position: relative; /* needed for ::after */
}

/* Fixed-column shadows — anchored to the sticky column itself so they stay
   correctly placed at any scroll offset, and spill onto the scrollable
   content the fixed column is floating above. Only shown while something is
   actually scrolled behind it. */
.entities-table.is-scrolled-right td.actionColumn::before,
.entities-table.is-scrolled-right th.actionHeader::before {
  content: "";
  position: absolute;
  left: -8px;
  top: 0;
  width: 8px;
  height: 100%;
  background: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.12),
    rgba(0, 0, 0, 0)
  );
  pointer-events: none;
}

.entities-table.is-scrolled-left th:nth-child(2)::after,
.entities-table.is-scrolled-left td:nth-child(2)::after {
  content: "";
  position: absolute;
  top: 0;
  right: -8px;
  width: 8px;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.12),
    rgba(0, 0, 0, 0)
  );
}

/* Branch's cell clips via its own inner span (see columns render), so the
   outer td can safely allow overflow here without losing text truncation —
   needed so the shadow above isn't cut off by the td's own overflow:hidden. */
.entities-table.is-scrolled-left td:nth-child(2) {
  overflow: visible !important;
}

/* Grip mark on each column's resize handle, so users can spot where to drag
   without having to hover first. */
.col-resize-handle::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 50%;
  left: 3px;
  width: 2px;
  background: #DEE2E6;
}

.drawer-title{
    border:none;
}

.drawer-tabs{
  border:none !important;
}
        
        `}
      </style>

      {/* Stock Out Modal */}
      <StockOutModal
        isOpen={stockOutModalOpen}
        onClose={() => setStockOutModalOpen(false)}
        onConfirm={handleStockOut}
        stockInstance={selectedStockInstanceForOut}
        sellableQty={
          selectedStockInstanceForOut?.inStock_Sellable?.[1]?.count || 0
        } // FIXED: Get sellable count correctly
        ref={stockOutModalRef}
      />
    </div>
  );
}
